import { useEffect } from 'react'
import { useNavigate } from 'react-router'

import { ROUTE_PATH_LIST_AUTH } from '../../../../../../constants/route'
import {
  isUserStatusBlocked,
  isUserStatusImported,
  isUserStatusUnexisted,
} from '../../../../../../utils/user'

export function useLoginFormPhoneUserStatusSideEffects({ userStatus }) {
  const navigate = useNavigate()

  useEffect(() => {
    if (
      isUserStatusBlocked(userStatus) ||
      isUserStatusImported(userStatus) ||
      isUserStatusUnexisted(userStatus)
    ) {
      navigate(ROUTE_PATH_LIST_AUTH.registration, { replace: true })
    }
  }, [userStatus])
}
